import React from 'react';
import autoBind from 'react-autobind';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { AppBar, Tabs, Tab, Grid, CircularProgress, Button } from '@material-ui/core/';
import { Book, FileCopy, People, PeopleOutline, SentimentDissatisfied, NoteAdd } from '@material-ui/icons/';
import Typography from '@material-ui/core/Typography';
import Pagination from "material-ui-flat-pagination";

import DashBoardArticle from 'components/DashboardArticle';
import FollowerCard from 'components/FollowerCard';
import links from 'utils/links';
import { Link } from 'react-router-dom';
import * as actions from '../redux/actions';

const styles = theme => ({
  root: {
    flexGrow: 1,
    width: '100%',
    backgroundColor: theme.palette.background.paper,
  },
  tabs: {
    position: "fixed",
    top: "100",
    backgroundColor: "white",
    zIndex: "100",
    width: "inherit"
  },
  tabContent: {
    padding: "80px 0px 10px 0px",
    backgroundColor: "white"
  },
  innerTabs: {
    backgroundColor: theme.palette.primary.main,
  },
  noItemContainer: {
    minHeight: "500px",
    paddingTop: "20%",
    textAlign: "center",
    color: theme.palette.secondary.main
  },
  noItemButton: {
    backgroundColor: theme.palette.ternary.main,
    color: "white"
  }
});

class PaginatedContainer extends React.Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }
  handlePageChange(e, newOffset) {
    const { limit } = this.props;
    this.props.onPageChange(limit, Math.floor(newOffset / limit));
  }
  render() {
    const { data, total, limit, loading, name, offset, noitems } = this.props;
    const noItem = React.cloneElement(noitems, {});
    const items = data.map((item, i) => (
      <Grid key={"draft" + i} item md={4} style={{ "padding": "10px" }}>
        {
          React.cloneElement(this.props.component, {
            data: item
          })
        }
      </Grid>
    ))
    if (data.length === 0)
      return noItem;
    return (
      <div style={{ "padding": "20px 0px 20px 0px" }}>
        {(total > limit) ? <div style={{ "textAlign": "center", "padding": "0px 0px 20px 0px" }}>
          <span>Showing {((offset * limit) + 1) + " to "} {(total > ((offset * limit) + limit)) ? ((offset * limit) + limit) : total} of {total} {name ? name : "items"}</span>
          <Pagination limit={limit} offset={offset * limit} total={total} onClick={this.handlePageChange} size="large" />
        </div> : ""}
        {
          loading ?
            <div style={{ "textAlign": "center", "verticalAlign": "middle" }}>
              <CircularProgress /> <br />
              Loading {name}
            </div>
            :
            <Grid container justify="center">
              {
                items
              }
            </Grid>
        }
        {(total > limit) ? <div style={{ "textAlign": "center", "padding": "20px 0px 0px 0px" }}>
          <Pagination limit={limit} offset={offset} total={total} onClick={this.handlePageChange} size="large" />
        </div> : ""}
      </div>
    )
  }
}

const NoArticleCont = ({ name, link, classes }) => {
  return (
    <div className={classes.noItemContainer}>
      No {name} Found
      <p><SentimentDissatisfied fontSize="large" /></p>
      <Link to={link}>
        <Button variant="contained" color="default" className={classes.noItemButton}>
          <NoteAdd fontSize="large" />
          Add a {name}
        </Button>
      </Link>
    </div>
  )
}

class MyArticles extends React.Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }
  state = {
    value: 0,
  };
  handleChange = (event, value) => {
    this.setState({ value });
  };
  onDeleteArticle(data) {
    this.props.data.dispatch(actions.deleteArticle(data));
  }
  onEateryPageChange = (limit, offset) => {
    const { type, data } = this.props;
    let listName = (type === "drafts") ? "myDraftEateries" : "myPublishedEateries";
    let offsetName = (type === "drafts") ? "myDraftEateriesOffset" : "myPublishedEateriesOffset";
    let flagName = (type === "drafts") ? "loadingDraftEateries" : "loadingPublishedEateries";
    let apiName = (type === "drafts") ? "getMyDrafts" : "getMyPublished";

    data.dispatch(actions.loadPaginatedData(listName, flagName, offsetName, apiName, limit, offset, "EATERY"));
  }
  onStoryPageChange = (limit, offset) => {
    const { type, data } = this.props;
    let listName = (type === "drafts") ? "myDraftStories" : "myPublishedStories";
    let offsetName = (type === "drafts") ? "myDraftStoriesOffset" : "myPublishedStoriesOffset";
    let flagName = (type === "drafts") ? "loadingDraftStories" : "loadingPublishedStories";
    let apiName = (type === "drafts") ? "getMyDrafts" : "getMyPublished";

    data.dispatch(actions.loadPaginatedData(listName, flagName, offsetName, apiName, limit, offset, "STORY"));
  }
  onListiclePageChange = (limit, offset) => {
    const { type, data } = this.props;
    let listName = (type === "drafts") ? "myDraftListicles" : "myPublishedListicles";
    let offsetName = (type === "drafts") ? "myDraftListiclesOffset" : "myPublishedListiclesOffset";
    let flagName = (type === "drafts") ? "loadingDraftListicles" : "loadingPublishedListicles";
    let apiName = (type === "drafts") ? "getMyDrafts" : "getMyPublished";

    data.dispatch(actions.loadPaginatedData(listName, flagName, offsetName, apiName, limit, offset, "LISTICLE"));
  }
  render() {
    const { data, classes, type } = this.props;
    const { additionalInfo } = data.contributorData;
    const { value } = this.state;

    let eateries = (type === "drafts") ? data.myDraftEateries : data.myPublishedEateries;
    let stories = (type === "drafts") ? data.myDraftStories : data.myPublishedStories;
    let listicles = (type === "drafts") ? data.myDraftListicles : data.myPublishedListicles;

    let eateriesLength = (type === "drafts") ? additionalInfo["eatery.drafted"] : additionalInfo["eatery.authored"];
    let storiesLength = (type === "drafts") ? additionalInfo["story.drafted"] : additionalInfo["story.authored"];
    let listiclesLength = (type === "drafts") ? additionalInfo["listicle.drafted"] : additionalInfo["listicle.authored"];

    let loadingEateries = (type === "drafts") ? data.loadingDraftEateries : data.loadingPublishedEateries;
    let loadingStories = (type === "drafts") ? data.loadingDraftStories : data.loadingPublishedStories;
    let loadingListicles = (type === "drafts") ? data.loadingDraftListicles : data.loadingPublishedListicles;

    let eateriesOffset = (type === "drafts") ? data.myDraftEateriesOffset : data.myPublishedEateriesOffset;
    let storiesOffset = (type === "drafts") ? data.myDraftStoriesOffset : data.myPublishedStoriesOffset;
    let listiclesOffset = (type === "drafts") ? data.myDraftListiclesOffset : data.myPublishedListiclesOffset;

    let isDraft = (type === "drafts") ? true : false;

    let noEateryItems = <NoArticleCont classes={classes} name="Eatery" link={links.addEatery()} />
    let noStoryItems = <NoArticleCont classes={classes} name="Story" link={links.addStory()} />
    let noListicleItems = <NoArticleCont classes={classes} name="Listicle" link={links.addListicle()} />

    return (
      <div>
        <div>
          <Tabs
            className={classes.innerTabs}
            value={this.state.value}
            indicatorColor="secondary"
            textColor="secondary"
            onChange={this.handleChange}
          >
            <Tab label={"Eateries (" + eateriesLength + ")"} />
            <Tab label={"Stories (" + storiesLength + ")"} />
            <Tab label={"Listicles (" + listiclesLength + ")"} />
          </Tabs>
          {value === 0 && <PaginatedContainer noitems={noEateryItems} component={<DashBoardArticle onDelete={this.onDeleteArticle} draft={isDraft} deleteLoader={data.deleting} />} offset={eateriesOffset} name="Eateries" onPageChange={this.onEateryPageChange} loading={loadingEateries} limit={10} total={eateriesLength} classes={classes} data={eateries} />}
          {value === 1 && <PaginatedContainer noitems={noStoryItems} component={<DashBoardArticle onDelete={this.onDeleteArticle} draft={isDraft} deleteLoader={data.deleting} />} offset={storiesOffset} name="Stories" onPageChange={this.onStoryPageChange} loading={loadingStories} limit={10} total={storiesLength} classes={classes} data={stories} />}
          {value === 2 && <PaginatedContainer noitems={noListicleItems} component={<DashBoardArticle onDelete={this.onDeleteArticle} draft={isDraft} deleteLoader={data.deleting} />} offset={listiclesOffset} name="Listicles" onPageChange={this.onListiclePageChange} loading={loadingListicles} limit={10} total={listiclesLength} classes={classes} data={listicles} />}
        </div>
      </div>
    )
  }
}

function TabContainer(props) {
  return (
    <Typography component="div" style={{ padding: 8 * 3 }}>
      {props.children}
    </Typography>
  );
}

TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
};

const MyFollowerCard = ({ data }) => {
  return (
    <FollowerCard data={data} />
  )
}

class MyFollowers extends React.Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }
  onPageChange(limit, offset) {
    const { data } = this.props;
    data.dispatch(actions.loadPaginatedData("myFollowers", "loadingMyFollowers", "myFollowersOffset", "getMyFollowers", limit, offset));
  }
  render() {
    const { data, classes } = this.props;
    const { myFollowers, myFollowersOffset, loadingMyFollowers } = data;
    const { additionalInfo } = data.contributorData;
    let noFollowers = <NoArticleCont classes={classes} name="Eatery" link={links.addEatery()} />
    return (
      <PaginatedContainer noitems={noFollowers} component={<MyFollowerCard />} offset={myFollowersOffset} name="Eateries" onPageChange={this.onPageChange} loading={loadingMyFollowers} limit={10} total={additionalInfo["follower.count"]} classes={classes} data={myFollowers} />
    )
  }
}

class IFollow extends React.Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }
  onPageChange(limit, offset) {
    const { data } = this.props;
    data.dispatch(actions.loadPaginatedData("iFollow", "loadingIFollow", "iFollowOffset", "getIFollow", limit, offset));
  }
  render() {
    const { data, classes } = this.props;
    const { iFollow, iFollowOffset, loadingIFollow } = data;
    const { additionalInfo } = data.contributorData;
    let noFollowers = <NoArticleCont classes={classes} name="Eatery" link={links.addEatery()} />
    return (
      <PaginatedContainer noitems={noFollowers} component={<MyFollowerCard />} offset={iFollowOffset} name="Eateries" onPageChange={this.onPageChange} loading={loadingIFollow} limit={10} total={additionalInfo["following.count"]} classes={classes} data={iFollow} />
    )
  }
}

class DashboardPage extends React.Component {
  handleChange = (event, value) => {
    // this.setState({ value });
    const { history } = this.props.data;
    history.push(history.location.pathname + "?tab=" + value);
  };
  getTab = (key) => {
    let keys = ["my-drafts", "my-published", "my-followers", "i-follow"];
    if (keys.indexOf(key) === -1)
      return "my-drafts";
    else
      return key;
  }
  render() {
    const { classes, data, tab } = this.props;
    const { additionalInfo } = data.contributorData;
    let totalDrafts = additionalInfo["listicle.drafted"] + additionalInfo["eatery.drafted"] + additionalInfo["story.drafted"];
    let totalPublished = additionalInfo["listicle.authored"] + additionalInfo["eatery.authored"] + additionalInfo["story.authored"];

    let currentTab = this.getTab(tab);
    return (
      <div className={classes.root}>
        <AppBar position="static" color="primary">
          <Tabs
            className={classes.tabs}
            value={currentTab}
            onChange={this.handleChange}
            variant="scrollable"
            scrollButtons="off"
            indicatorColor="secondary"
            textColor="secondary"
          >
            <Tab value="my-drafts" label={"My Drafts (" + totalDrafts + ")"} icon={<FileCopy />} />
            <Tab value="my-published" label={"My Published (" + totalPublished + ")"} icon={<Book />} />
            <Tab value="my-followers" label="My Followers" icon={<People />} />
            <Tab value="i-follow" label="I'm Following" icon={<PeopleOutline />} />
            {/*<Tab label="Applause Received" icon={<ThumbUp />} />*/}
          </Tabs>
        </AppBar>
        <div className={classes.tabContent}>
          {currentTab === "my-drafts" && <MyArticles classes={classes} type="drafts" data={data} />}
          {currentTab === "my-published" && <MyArticles classes={classes} type="published" data={data} />}
          {currentTab === "my-followers" && <MyFollowers classes={classes} data={data} />}
          {currentTab === "i-follow" && <IFollow classes={classes} data={data} />}
          {currentTab === 4 && <TabContainer>This information will be shortly available!</TabContainer>}
        </div>
      </div >
    );
  }
}

DashboardPage.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(DashboardPage);
